/*  Empty Cart Cross-sell Slider  */
(function() {
  var autoSlideEnabled = true;
  var sliderInstance = null;

  function destroySlider() {
    if (sliderInstance) {
      sliderInstance.destroy();
      sliderInstance = null;
    }
  }

  function initEmptyCartSlider() {
    destroySlider();

    var slider = document.getElementById('emptyCartSlider');
    if (!slider) return;

    var track = document.getElementById('emptyCartTrack');
    if (!track) return;

    var existingClones = track.querySelectorAll('.empty-cart-state__slide-clone');
    existingClones.forEach(function(clone) { clone.remove(); });

    var slides = track.querySelectorAll('.empty-cart-state__slide');
    var dots = document.querySelectorAll('#emptyCartDots .empty-cart-state__dot');

    if (slides.length === 0) return;

    var originalSlideCount = slides.length;

    for (var i = 0; i < originalSlideCount; i++) {
      var clone = slides[i].cloneNode(true);
      clone.classList.add('empty-cart-state__slide-clone');
      track.appendChild(clone);
    }

    var allSlides = track.querySelectorAll('.empty-cart-state__slide');

    var currentIndex = 0;
    var autoSlideInterval = null;
    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var destroyed = false;
    var isAnimating = false;

    function getVisibleSlides() {
      return 1;
    }

    function getMaxIndex() {
      return originalSlideCount;
    }

    function updateSlider(animate) {
      if (destroyed || !allSlides[0]) return;
      var slideWidth = allSlides[0].getBoundingClientRect().width;
      if (slideWidth === 0) return;
      var gap = 20;
      var offset = currentIndex * (slideWidth + gap);
      
      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.4s ease';
      }
      track.style.transform = 'translateX(-' + offset + 'px)';

      var activeDotIndex = currentIndex % originalSlideCount;
      dots.forEach(function(dot, index) {
        dot.classList.toggle('active', index === activeDotIndex);
      });
      
      allSlides.forEach(function(slide, index) {
        var isSlideActive = (index % originalSlideCount) === activeDotIndex;
        slide.classList.toggle('active', isSlideActive);
      });
    }

    function nextSlide() {
      if (destroyed || isAnimating) return;
      if (originalSlideCount <= getVisibleSlides()) return;

      currentIndex++;
      updateSlider(true);

      if (currentIndex === getMaxIndex()) {
        isAnimating = true;
        setTimeout(function() {
          if (destroyed) return;
          currentIndex = 0;
          updateSlider(false);
          isAnimating = false;
        }, 400);
      }
    }

    function prevSlide() {
      if (destroyed || isAnimating) return;
      if (originalSlideCount <= getVisibleSlides()) return;

      if (currentIndex === 0) {
        currentIndex = getMaxIndex();
        updateSlider(false);
        void track.offsetHeight;
      }
      
      currentIndex--;
      updateSlider(true);
    }

    function startAutoSlide() {
      if (!autoSlideEnabled || destroyed) return;
      stopAutoSlide();
      autoSlideInterval = setInterval(nextSlide, 3000);
    }

    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
      }
    }

    function onTouchStart(e) {
      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      stopAutoSlide();
    }
    function onTouchMove(e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }
    function onTouchEnd() {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { nextSlide(); } else { prevSlide(); }
      }
      startAutoSlide();
    }
    function onMouseDown(e) {
      startX = e.clientX;
      currentX = startX;
      isDragging = true;
      stopAutoSlide();
      e.preventDefault();
    }
    function onMouseMove(e) {
      if (!isDragging) return;
      currentX = e.clientX;
    }
    function onMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { nextSlide(); } else { prevSlide(); }
      }
      startAutoSlide();
    }
    function onMouseLeave() {
      if (isDragging) {
        isDragging = false;
      }
      startAutoSlide();
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd);

    track.addEventListener('mousedown', onMouseDown);
    track.addEventListener('mousemove', onMouseMove);
    track.addEventListener('mouseup', onMouseUp);
    track.addEventListener('mouseleave', onMouseLeave);

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        currentIndex = parseInt(dot.dataset.index);
        updateSlider(true);
        stopAutoSlide();
        startAutoSlide();
      });
    });

    slider.addEventListener('mouseenter', stopAutoSlide);
    slider.addEventListener('mouseleave', startAutoSlide);

    window.addEventListener('resize', function() { updateSlider(false); });

    updateSlider(false);
    startAutoSlide();

    sliderInstance = {
      update: function() { updateSlider(false); },
      destroy: function() {
        destroyed = true;
        stopAutoSlide();
        track.removeEventListener('touchstart', onTouchStart);
        track.removeEventListener('touchmove', onTouchMove);
        track.removeEventListener('touchend', onTouchEnd);
        track.removeEventListener('mousedown', onMouseDown);
        track.removeEventListener('mousemove', onMouseMove);
        track.removeEventListener('mouseup', onMouseUp);
        track.removeEventListener('mouseleave', onMouseLeave);
        window.removeEventListener('resize', updateSlider);
      }
    };
  }

  function setupDrawerObserver() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' || mutations[i].attributeName === 'open') {
          if (drawer.classList.contains('active') || drawer.hasAttribute('open')) {
            setTimeout(function() {
              var slider = document.getElementById('emptyCartSlider');
              if (slider) {
                if (sliderInstance) {
                  sliderInstance.update();
                } else {
                  initEmptyCartSlider();
                }
              }
            }, 350);
          } else {
            if (sliderInstance) {
              destroySlider();
            }
          }
        }
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });

    var contentObserver = new MutationObserver(function() {
      var slider = document.getElementById('emptyCartSlider');
      if (slider && (drawer.classList.contains('active') || drawer.hasAttribute('open'))) {
        setTimeout(initEmptyCartSlider, 100);
      }
    });

    contentObserver.observe(drawer, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDrawerObserver);
  } else {
    setupDrawerObserver();
  }

  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(function() {
      var drawer = document.getElementById('Cart-Drawer');
      var slider = document.getElementById('emptyCartSlider');
      if (slider && drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'))) {
        initEmptyCartSlider();
      }
    }, 800);
  });
})();
